import useSocketSync from '@/application/useSocketSync';
import { ReactNode } from 'react';

export const SocketSyncProvider = ({ children }: { children: ReactNode }) => {
  useSocketSync();

  return <>{children}</>;
};
